import script from "./KinesisVideoStreamsWebrtc.vue?vue&type=script&lang=ts&setup=true"
export * from "./KinesisVideoStreamsWebrtc.vue?vue&type=script&lang=ts&setup=true"

import "./KinesisVideoStreamsWebrtc.vue?vue&type=style&index=0&id=7b282e50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b282e50"]])

export default __exports__